<template>
  <div>
    <app-navbar showToggle v-on:toggleDrawer="toggleDrawer"/>
    <app-drawer v-model="drawer" />
    <slot />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import AppNavbar from "./AppNavbar.vue";
import AppDrawer from "./AppDrawer.vue";

export default Vue.extend({
  data () {
    return {
      drawer: false
    }
  },
  components: {
    AppNavbar,
    AppDrawer
  },
  methods: {
    toggleDrawer: function () {
      this.drawer = !this.drawer
    }
  }
});
</script>
